import React, { useEffect } from 'react'
import { Field, FieldProps, useFormikContext } from 'formik';
import { Input } from 'reactstrap';
import env from 'environment_system/env_system';
import ErrorTooltip from 'Components/ErrorTooltip';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';
import { isFormUnchanged } from 'GenericForms/Helper';

interface SpOpFuelConsumptionComponentType {
    fuelConsumptions: any
    machineryEnabled?: boolean,
    revPopup: boolean
    editValues?: any;
    setEditValues?: any;
    setEditFieldValue?: any;
    spOpConstant: number;
}

const SpOpFuelConsumptionComponent = ({
    fuelConsumptions,
    machineryEnabled,
    editValues,
    setEditValues,
    revPopup,
    spOpConstant
}: SpOpFuelConsumptionComponentType) => {
    const { initialValues, values, errors, touched }:
        { initialValues: any, values: any, errors: any, touched: any, setFieldValue: any } = useFormikContext();
    const { discardwarning } = useEditReport();

    useEffect(() => {
        if (editValues && Array.isArray(editValues?.chief_engineer?.special_operation_fuel) &&
            !isFormUnchanged(initialValues?.fuelConsumption, values?.fuelConsumption)) {
            setEditValues({
                ...editValues,
                chief_engineer: {
                    ...editValues?.chief_engineer,
                    special_operation_fuel: [
                        ...editValues?.chief_engineer?.special_operation_fuel?.filter((item: any) => item.special_operation !== spOpConstant),
                        ...values?.fuelConsumption?.filter((item: any) => item.special_operation === spOpConstant)
                    ]
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.fuelConsumption])

    return (
        <div className='d-inline-block'>
            <div className="input-group">
                <Field name={`fuelConsumption.${values.fuelConsumption.indexOf(fuelConsumptions)}.total_fuel_consumption`}>
                    {({ field, form }: FieldProps) => (
                        <Input
                            onFocus={(e) => e.target.select()}
                            type="text"
                            className="form-control max-width-7 text-right"
                            id={`fuelConsumption_${values.fuelConsumption.indexOf(fuelConsumptions)}`}
                            name={field.name}
                            onChange={(e: any) => {
                                form.handleBlur(e);
                                form.setFieldValue(field.name, e.target.value);
                            }}
                            onBlur={(e: any) => {
                                form.handleBlur(e);
                                form.setFieldValue(field.name, e.target.value);
                            }}
                            defaultValue={values.fuelConsumption[values.fuelConsumption.indexOf(fuelConsumptions)]?.total_fuel_consumption}
                            disabled={machineryEnabled}
                        />
                    )}
                </Field>
                <div className="input-group-text">mt</div>
            </div>
            {
                errors?.fuelConsumption && touched?.fuelConsumption &&
                touched?.fuelConsumption[values.fuelConsumption.indexOf(fuelConsumptions)]?.total_fuel_consumption &&
                errors?.fuelConsumption[values.fuelConsumption.indexOf(fuelConsumptions)]?.total_fuel_consumption &&
                env?.form_validation === true && !revPopup && !discardwarning &&
                <ErrorTooltip
                    target={`fuelConsumption_${values.fuelConsumption.indexOf(fuelConsumptions)}`}
                    message={errors?.fuelConsumption[values.fuelConsumption.indexOf(fuelConsumptions)]?.total_fuel_consumption}
                    open={
                        (errors && errors?.fuelConsumption[values.fuelConsumption.indexOf(fuelConsumptions)]?.total_fuel_consumption) ?
                            true : false
                    }
                />
            }
        </div>
    )
}

export default SpOpFuelConsumptionComponent